// Build-time generated translation bundles (one per language).
// Populated by scripts/fetch-translations.js from Loco.
import en from './en.json';
import ru from './ru.json';
import ptBR from './pt-BR.json';
import nlNL from './nl-NL.json';
import fr from './fr.json';
import de from './de.json';
import es from './es.json';
import sv from './sv.json';
import ja from './ja.json';
import ko from './ko.json';
import zhHans from './zh-Hans.json';
import zhHant from './zh-Hant.json';
import it from './it.json';
import pl from './pl.json';
import tr from './tr.json';

const bundles = {
  en,
  ru,
  'pt-BR': ptBR,
  'nl-NL': nlNL,
  fr,
  de,
  es,
  sv,
  ja,
  ko,
  'zh-Hans': zhHans,
  'zh-Hant': zhHant,
  it,
  pl,
  tr,
};

// Aliases for languages we don't ship a bundle for — they route to a
// visually-compatible bundle instead.
const aliases = { 'zh-HK': 'zh-Hant' };

export function getLang(search) {
  const requested = new URLSearchParams(search).get('lang');
  const resolved = aliases[requested] || requested;
  return bundles[resolved] ? resolved : 'en';
}

// Loco uses [name] placeholders. Substitute with values from `vars`.
export function makeT(lang) {
  const primary = bundles[lang] ?? bundles.en;
  const fallback = bundles.en;
  return (key, vars = {}) => {
    const raw = primary[key] || fallback[key] || key;
    return raw.replace(/\[([^\]]+)\]/g, (m, name) =>
      Object.prototype.hasOwnProperty.call(vars, name) ? vars[name] : m,
    );
  };
}
